import {
  PaymentMethod,
  EPaymentProvider,
  EBEPaymentMethodsName,
  EStripePaymentMethods,
} from '../../../../contracts';
import { SavedCardFormProps } from '../SavedCards/SavedCards';

export function createStripeSavedCardFinalizeRequestBody(
  formValues: SavedCardFormProps,
  selectedPaymentMethod: PaymentMethod
) {
  return {
    paymentProvider: EPaymentProvider.stripe,
    receipt_email: formValues.email,
    paymentMethodDisplayName: selectedPaymentMethod?.paymentMethodDisplayName,
    paymentMethodId: selectedPaymentMethod?.id,
    params: {
      paymentMethodId: formValues.cardID,
      stripeCustomerId: formValues.pspCustomerId,
    },
  };
}

const PAYMENT_METHOD_NAME_TO_STRIPE_PAYMENT_METHOD_NAME_MAP: Partial<
  Record<EBEPaymentMethodsName, EStripePaymentMethods>
> = {
  [EBEPaymentMethodsName.link]: EStripePaymentMethods.link,
  [EBEPaymentMethodsName.google]: EStripePaymentMethods.google,
};

export const getStripePaymentMethodName = (paymentMethodName: EBEPaymentMethodsName) => {
  return PAYMENT_METHOD_NAME_TO_STRIPE_PAYMENT_METHOD_NAME_MAP[paymentMethodName];
};
